
let treeChildren = (index, data, Vue) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 21; i++) {
      var obj = {};
      let ball = ('0' + i).slice(-2);
      obj.title = `${ball}`;
      obj.align = 'center';

      var n = 0;

      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {

        if (row.row.ball_json.numSpread.nums[ball] == 0) {
          var num = row.row.ballList[n % 8];

          n += 1;
          return <span class="red">{num}</span>;
        } else if (Vue.divideList[ball] > row.index) {

          return <span class="divide_lost_info lost_info">{row.row.ball_json.numSpread.nums[ball]}</span>;
        } else {
          return <span class="lost_info">{row.row.ball_json.numSpread.nums[ball]}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
var lostTreeChildren = (index, data) => {
  var arr = [];
  if (data) {
    for (let i = 1; i < 21; i++) {
      var obj = {};
      let ball = ('0' + i).slice(-2);
      obj.title = `${ball}`;

      obj.align = 'center';
      obj.className = `tree_table_children_${index}`;
      obj.render = (h, row) => {
        var key = row.row.key;
        var n = row.row.lost.ballJson['numSpread'].nums[ball];
        if (key != 'averageOmit') {
          return <span>{n[key] ? n[key] : 0}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};
let xingtaiChildren = data => {
  var arr = [];
  var shape = ['和值', '大', '小', '和', '单', '双', '尾大', '尾小'];
  var str = ['sum', 'big', 'small', 'flat', 'single', 'double', 'big', 'small'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';
      obj.className = `join_table_children`;
      obj.render = (h, row) => {
        if (i == 0) {
          return <span>{row.row.sum_json.sum}</span>;
        } else if (0 < i && i <= 3) {
          var divideList = data[0].sum_json.bigSmall[str[i]];
          var n = row.row.sum_json.bigSmall[str[i]];
          if (n == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
        } else if (3 < i && i < 6) {
          var divideList = data[0].sum_json.singleDouble[str[i]];
          var n = row.row.sum_json.singleDouble[str[i]];
          if (row.row.sum_json.singleDouble[str[i]] == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }
        } else if (i >= 6) {
          var divideList = data[0].sum_json.tailBigSmall[str[i]];
          var n = row.row.sum_json.tailBigSmall[str[i]];

          if (row.row.sum_json.tailBigSmall[str[i]] == 0) {
            return <span class={`table_join_${i % 2}`}>{shape[i]}</span>;
          } else if (divideList > row.index) {
            return <span class="divide_lost_info lost_info">{n}</span>;
          } else {
            return <span class="lost_info">{n}</span>;
          }

        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

var lostXtChildren = (data, index) => {
  var arr = [];
  var shape = ['和值', '大', '小', '和', '单', '双', '尾大', '尾小'];
  var str = ['sum', 'big', 'small', 'flat', 'single', 'double', 'big', 'small'];
  if (data) {
    for (let i = 0; i < shape.length; i++) {
      var obj = {};
      obj.title = `${shape[i]}`;
      obj.align = 'center';

      obj.className = `join_table_children`;
      obj.render = (h, row) => {

        var key = row.row.key;
        var n = row.row.lost.sumJson;
        if (i == 0) {
          return <span>0</span>;
        }
        if (0 < i && i <= 3) {
          return <span>{n.bigSmall[str[i]][key] || 0}</span>;
        } else if (3 < i && i < 6) {
          return <span>{n.singleDouble[str[i]][key] || 0}</span>;
        } else if (i >= 6) {
          return <span>{n.tailBigSmall[str[i]][key] || 0}</span>;
        }
      };
      arr.push(obj);
    }
    return arr;
  }
};

const hpten = (data, ballindex) => {
  let list = Vue => {
    let arr = [
      {
        title: '期数',
        align: 'center',
        key: 'issue_id',
        className: `table_issueId`,
        width: 140
      },
      {
        title: '开奖号码',
        align: 'center',
        width: 180,
        className: `table_issueId`,
        render: (h, { row }) => {
          let ball = row.balls.split(',')
          return (
            <div class="pk_balls">
              {ball.map((x, i) => {
                return (
                  <span class={'ball_red'} key={i}>
                    {x}
                  </span>
                );
              })}
            </div>
          );
        }
      },
      {
        title: `号码分布`,
        align: 'center',
        className: `table_issueId`,
        children: treeChildren(ballindex, data, Vue)
      },
      {
        title: '总分',
        align: 'center',
        className: `table_issueId`,
        children: xingtaiChildren(data)
      }
    ];
    return arr;
  };
  let lostList = Vue => {
    let arr = [
      {
        title: '数据统计',
        align: 'center',
        key: 'name',
        className: `table_issueId`,
        width: 320
      },
      {
        title: `号码分布`,
        align: 'center',
        className: `table_issueId`,
        children: lostTreeChildren(ballindex, data)
      },
      {
        title: '总分',
        align: 'center',
        className: `table_issueId`,
        children: lostXtChildren(data, ballindex)
      }
    ];
    return arr;
  };
  return { list, lostList };
};

export default hpten;



// WEBPACK FOOTER //
// ./src/pages/Trend/Haomafenbu/columns/hpten.js